
import "./stylemain.css";
import "./App.css";
import { useRef } from "react";
import Journey from "./components/journeys/Journey";
import OurFirms from "./components/our-firms/OurFirms";
import Dashboard from "./components/dashboard/Dashboard";
import Photos from "./components/photos/Photos";
import Videos from "./components/videos/Videos";
import Gallery from "./components/gallery/Gallery";
import Family from "./components/family/Family";
import FamilyChart from "./components/family-chart/FamilyChart";
import WeddingPartners from "./components/wedding-partners/WeddingPartners";
import { BrowserRouter, Route, Routes, useLocation, useNavigate, useParams } from "react-router-dom";
import Error404 from "./components/error404/Error404";
import Login from "./components/login/Login";
import { getDataFromStore, storeInData } from "./utils/CookiesUtils";
import { AUTH_TOKEN_KEY, LOGIN_DATA } from "./utils/Constants";
import { useEffect, useState } from "react";
import CustomAccordian from "./components/testing/CustomAccordian";
import OurBlessings from "./components/our-blessings/OurBlessings";
import OurMemories from "./components/our-memories/OurMemories";
import Invitation from "./components/invitation/Invitation";
import "animate.css";
import DateAndTime from "./components/date-and-time/DateAndTime";
import Profile from "./components/profile/Profile";
import SelfAboutUs from "./components/about-us/SelfAboutUs";
import VideoPlayer from "./components/common/VideoPlayer";
import ImageGallery from "./components/gallery-image/ImageGallery";
import LiveWedding from "./components/live-wedding/LiveWedding";
import BrandAboutUs from "./components/about-us/BrandAboutUs";
import NewBlessings from "./components/new-pages/Blessings"
import NewJourney from "./components/new-pages/Journey"
import NewMemories from "./components/new-pages/Memories"
import NewGroomSquad from "./components/new-pages/Groomsquad"
import NewQuiz from "./components/new-pages/Quiz";
import LandscapeWarning from "./components/new-pages/LandscapeWarning"
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import RippleInitializer from "./components/new-pages/RippleInitializer";
import { faL } from "@fortawesome/free-solid-svg-icons";
import { apiHandler } from "./utils/apiHandler";

const AnimatedRoutes = () => {
  // const { username } = useParams();
  //  localStorage.getItem(`AUTH_TOKEN_KEY_${loginData?.eventURL}`)
  const navigate = useNavigate();
  const location = useLocation();
  let isAuthenticated = ''
  const prevLocation = useRef(location.pathname);
  const match = location.pathname.match(/\/Login\/([^/]+)/);
  const username = match?.[1] || '';
  const noAnimationPaths = [``];
  const pathParts = location.pathname.split("/").filter(Boolean);
  const isHome = pathParts.length === 1;
  const [showRoutes, setShowRoutes] = useState(false);
  const [loginData, setLogInData] = useState(null)
  const getPathWithoutUsername = (path) => {
    const parts = path.split("/").filter(Boolean);
    if (parts.length > 1) parts.shift(); // remove username
    return "/" + parts.join("/");
  };
  const redirectToPage = localStorage.getItem("redirectToPage")?.split("/").filter(Boolean)
  const animationKey = getPathWithoutUsername(location.pathname);
  const usernamenew = pathParts[0];
  let isAuthenticatedNew = (localStorage.getItem(`AUTH_TOKEN_KEY_${usernamenew}`));
  useEffect(() => {
    const pathParts = location.pathname.split("/").filter(Boolean);
    let username = pathParts[0];
    if (pathParts.includes("Login")) {
      username = pathParts[1]
    }
    // Only run check if on root OR if first segment is a username
    if (pathParts.length === 0) {
      // No username at all, go to main website
      window.location.href = "https://weddingpatrika.com";
      return;
    }
    const secondPath = pathParts[1];
    isAuthenticatedNew = localStorage.getItem(`AUTH_TOKEN_KEY_${username}`)
    // If you want to treat ONLY valid usernames, you can validate here:
    const reservedRoutes = [
      "Photos", "Gallery", "Videos", "WeddingPartner", "MeetFamily",
      "FamilyChart", "Blessings", "Memories", "Invitation", "SelfAboutUs",
      "BrandAboutUs", "Testing", "DateAndTimings", "Profile", "GalleryImage",
      "VideoPlayer", "LiveWedding", "OurMemoriesNew", "FriendSquad", "QuizGame",
      "Login"
    ];

    // Agar dusra segment reserved hai → guest login skip karo
    // if (reservedRoutes.includes(secondPath)) {
    //   return;
    // }

    // Agar pehla segment reserved nahi hai → guest login try karo
    const isUsernameRoute = !reservedRoutes.includes(username);
    if (true) {
      const fetchGuestLogin = async () => {
        try {
          let res = await apiHandler.post("/guest/login", {
            title: `https://wedding-patrika/${username}`,

          });
          let hii = res?.data?.eventPrivacy
          console.log('hii')
          setLogInData(res?.data)
          localStorage.setItem(`logindata_${res?.data?.eventURL}`, JSON.stringify(res?.data))
          if (!hii) {
            if (localStorage.getItem(`loginData_${res.data?.eventURL}`) === null) {
              localStorage.setItem(`AUTH_TOKEN_KEY_${res?.data?.eventURL}`, "Success")
              localStorage.setItem(`logindata_${res?.data?.eventURL}`, JSON.stringify(res?.data))
              localStorage.setItem(`animationsEnabled_${res?.data?.eventURL}`, "true")
              // navigate(`/${username}`);
            }
          }

        } catch (err) {
          window.location.href = "https://weddingpatrika.com";
        }
      };
      if (loginData === null) {
        fetchGuestLogin();
      }
    }

  }, [location]);
  useEffect(() => {
    // Ensure animation works even on reload
    const timeout = setTimeout(() => setShowRoutes(true), 50);
    return () => clearTimeout(timeout);
  }, []);
  useEffect(() => {
    console.log(loginData?.eventPrivacy)

    if (loginData !== null) {
      if (!isAuthenticatedNew) {


        // if(username === undefined){
        //   navigate('/*')
        // }
        const pathParts = location.pathname.split("/").filter(Boolean); // removes empty
        const username = pathParts[0];
        if (!localStorage.getItem(`redirectToPage_${username}`) && !location.pathname.includes("Login")) {
          const currentPath = window.location.pathname;
          localStorage.setItem(`redirectToPage_${username}`, currentPath);
        }
        if (username && !location.pathname.includes("Login")) {
          window.
            window.location.href = `/Login/${username}`;
        }

      }
    }

  }, [loginData]);





  useEffect(() => {
    if (location.pathname === "GalleryImage") {
      prevLocation.current = "/photos";
    } else {
      prevLocation.current = location.pathname;
    }
  }, [location.pathname]);


  if (!showRoutes) return null;

  return (
    <TransitionGroup component={null}>
      {(!isHome) ? (
        <CSSTransition
          key={animationKey}
          classNames="navigate"
          timeout={400}
          enter={
            prevLocation.current.includes("/Gallery") ||
              prevLocation.current.includes("/photos") ||
              prevLocation.current.includes("/videos") ||
              prevLocation.current.includes("/GalleryImage")
              ? false
              : true
          }
          exit={true}
          appear={true}
        >
          <div className="route-container">
            <Routes location={location} key={location.pathname}>
              {!isAuthenticatedNew ? (
                <>
                  <Route path="/Login/:username" element={<Login />} />
                </>
              ) : (
                <>

                  <Route path="/Login/:username" element={<Login />} />
                  <Route path="/:name/Journeys/:id" element={<NewJourney />} />
                  <Route path="/:name/Firms/:id" element={<OurFirms />} />
                  <Route path="/:name/Photos/:id" element={<Photos />} ></Route>
                  <Route path="/:name/Gallery/:id" element={<Gallery />}></Route>
                  <Route path="/:name/Videos/:id" element={<Videos />} />
                  <Route path="/:name/WeddingPartner/:id" element={<WeddingPartners />} />
                  <Route path="/:name/MeetFamily/:id" element={<Family />} />
                  <Route path="/:name/FamilyChart/:id/:slug" element={<FamilyChart />} />
                  <Route path="/:name/Blessings/:id" element={<NewBlessings />} />
                  <Route path="/:name/Memories/:id" element={<NewMemories />} />
                  <Route path="/:name/Invitation/:id" element={<Invitation />} />
                  <Route path="/:name/SelfAboutUs" element={<SelfAboutUs />} />
                  <Route path="/:name/BrandAboutUs" element={<BrandAboutUs />} />
                  <Route path="/Testing" element={<CustomAccordian />} />
                  <Route path="/:name/DateAndTimings/:id" element={<DateAndTime />} />
                  <Route path="/:name/Profile/:id" element={<Profile />} />
                  <Route path="/:name/GalleryImage/:id/:slug" element={<ImageGallery />} />
                  <Route path="/:name/VideoPlayer/:id/:slug" element={<VideoPlayer />} />
                  <Route path="/:name/LiveWedding/:id" element={<LiveWedding />} />
                  <Route path="/:name/OurMemoriesNew" element={<NewMemories />} />
                  <Route path="/:name/FriendSquad/:id" element={<NewGroomSquad />} />
                  <Route path="/:name/QuizGame/:id" element={<NewQuiz />} />
                  <Route path="*" element={<Error404 />} />
                  <Route path="/:name" element={<Dashboard />} />
                </>
              )}
            </Routes>
          </div>
        </CSSTransition>
      ) : (

        <Routes location={location} key={location.pathname}>
          {!isAuthenticatedNew ? (
            <Route path="/Login/:username" element={<Login />} />
          ) : (
            <>
              <Route path="/Login/:username" element={<Login />} />
              <Route path="/:name/Journeys/:id" element={<NewJourney />} />
              <Route path="/:name/Firms/:id" element={<OurFirms />} />
              <Route path="/:name/Photos/:id" element={<Photos />} ></Route>
              <Route path="/:name/Gallery/:id" element={<Gallery />}></Route>
              <Route path="/:name/Videos/:id" element={<Videos />} />
              <Route path="/:name/WeddingPartner/:id" element={<WeddingPartners />} />
              <Route path="/:name/MeetFamily/:id" element={<Family />} />
              <Route path="/:name/FamilyChart/:id/:slug" element={<FamilyChart />} />
              <Route path="/:name/Blessings/:id" element={<NewBlessings />} />
              <Route path="/:name/Memories/:id" element={<NewMemories />} />
              <Route path="/:name/Invitation/:id" element={<Invitation />} />
              <Route path="/:name/SelfAboutUs" element={<SelfAboutUs />} />
              <Route path="/:name/BrandAboutUs" element={<BrandAboutUs />} />
              <Route path="/Testing" element={<CustomAccordian />} />
              <Route path="/:name/DateAndTimings/:id" element={<DateAndTime />} />
              <Route path="/:name/Profile/:id" element={<Profile />} />
              <Route path="/:name/GalleryImage/:id/:slug" element={<ImageGallery />} />
              <Route path="/:name/VideoPlayer/:id/:slug" element={<VideoPlayer />} />
              <Route path="/:name/LiveWedding/:id" element={<LiveWedding />} />
              <Route path="/:name/OurMemoriesNew" element={<NewMemories />} />
              <Route path="/:name/FriendSquad/:id" element={<NewGroomSquad />} />
              <Route path="/:name/QuizGame/:id" element={<NewQuiz />} />
              <Route path="*" element={<Error404 />} />
              <Route path="/:name" element={<Dashboard />} />
            </>
          )}
        </Routes>

      )}

    </TransitionGroup>
  );
};


function App() {


  const [isLandscape, setIsLandscape] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const checkDeviceAndOrientation = () => {
    const isMobileDevice = /Mobi|Android/i.test(navigator.userAgent);
    const isLandscapeMode = window.innerHeight < window.innerWidth;
    setIsMobile(isMobileDevice);
    setIsLandscape(isMobileDevice && isLandscapeMode);
  };

  useEffect(() => {
    checkDeviceAndOrientation();
    window.addEventListener('resize', checkDeviceAndOrientation);

    // Disable right-click
    const handleContextMenu = (e) => e.preventDefault();
    document.addEventListener("contextmenu", handleContextMenu);

    // Clean up on component unmount
    return () => {
      window.removeEventListener('resize', checkDeviceAndOrientation);
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);


  return (
    <BrowserRouter>
      <InnerApp isLandscape={isLandscape} isMobile={isMobile} />
    </BrowserRouter>
  );
}

function InnerApp({ isLandscape, isMobile }) {
  const location = useLocation();
  const allowLandscape =

    location.pathname.toLowerCase().includes("/videoplayer");
  if ((isLandscape && isMobile) && !allowLandscape) {
    return <LandscapeWarning />;
  }


  return (
    <>
      <RippleInitializer />
      <AnimatedRoutes />
    </>
  );
}

export default App;